<template>
  <v-app :class="{'is-authenticated': session.state === 'authenticated' }">
    <request_interceptor></request_interceptor>
    <preloader style="position: fixed; width: 100vw; height: 100vh; z-index: 1000; left:0; top:0;" v-if="currentInterface === 'preloader'"></preloader>
    <router-view v-if="currentInterface === 'publicRoute'"></router-view>
    <v-component :is="currentInterface" v-if="currentInterface !== 'preloader' && currentInterface !== 'publicRoute'"></v-component>

    <!-- Update Available Snackbar -->
    <v-snackbar
      v-model="updateAvailable"
      :timeout="-1"
      color="info"
      top
      right
      vertical
    >
      <div class="d-flex align-center">
        <v-icon left>mdi-update</v-icon>
        <span>{{ $t('app.update_available') }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="reloadApp"
        >
          {{ $t('app.update_now') }}
        </v-btn>
        <v-btn
          icon
          small
          v-bind="attrs"
          @click="updateAvailable = false"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>


import { sessionStore } from '@/store/pinia/sessionStore'

import userInterface from './components/_app/interface.vue'
import scannerInterface from './components/_app/scannerInterface.vue'
import posInterface from './views/ScannerPOC.vue'
import storageInterface from './views/StorageScannerPOC.vue'
import login from './components/_app/login/index.vue'
import preloader from './components/_app/preloader.vue'
import request_interceptor from "./components/_app/request_interceptor";

export default {

  name: 'App',
  components: {userInterface, scannerInterface, posInterface, storageInterface, login, preloader, request_interceptor},

  data() {
    return {
      show: true,
      updateAvailable: false,
    }
  },

  setup() {

    const session = sessionStore();

    return {
      // you can return the whole store instance to use it in the template
      session,
    }

  },


  computed: {


    currentInterface: function() {

      if (this.session.state === 'initializing' || this.session.state === 'deauthenticating') {
        return 'preloader';
      }
      if (this.session.state === 'authenticated') {
        if (this.session.scanner_mode === 'pos') return 'posInterface';
        if (this.session.scanner_mode === 'storage') return 'storageInterface';
        if (this.session.scanner_mode !== null) return 'scannerInterface';
        return 'userInterface';
      }

      const publicRoutes = ['forgot-password', 'reset-password', '2fa-verification'];
      if (publicRoutes.includes(this.$route.name)) {
        return 'publicRoute';
      }

      return 'login'

    },

    currentLocale: function() {

      return this.session.locale;

    },



  },


  watch: {

    currentLocale: function(newVal)  {


      this.$i18n.locale = newVal;

    }

  },

  async beforeMount() {

    let self = this;
    await self.session.init();

  },

  mounted: function () {

    let self = this;

   setTimeout(function(){

      if(self.session.dark_mode === true){

        self.$vuetify.theme.dark = true;

      }

    },500);


    this.$i18n.locale = this.session.locale;

    // Service worker update notification
    document.addEventListener('swUpdated', () => {
      self.updateAvailable = true;
    }, { once: true });

  },

  methods: {
    reloadApp() {
      window.location.reload();
    }
  }

}
</script>


<style lang="scss">

@import './scss/master.scss';

.v-application {

  &.theme--light {
    .v-application--wrap {
      background-color: #fbfbfb;
    }
  }


  .v-application--wrap {
    background: rgb(4, 6, 18);
  }

  .slide-enter-active {
    animation: bounce-in 0.5s;
  }

  .slide-leave-active {
    animation: bounce-in 0.5s reverse;
  }

  .fade-enter-active {

    animation: fade-in 0.5s reverse;

  }

  .fade-enter-leave {

    animation: fade-in 0.5s reverse;

  }

  @keyframes bounce-in {
    0% {
      transform: scale(5);
      opacity: 0;
    }
    50% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.2);
    }
  }


  @keyframes fade-in {
    0% {

      opacity: 0;
    }
    50% {
      opacity: 0.7;
    }
    100% {
      opacity: 1;
    }
  }


}

</style>



